import { Alert, Button, FormControl, FormGroup, Modal } from "react-bootstrap";
import { useState } from "react";
import Switch from "react-switch";
import {Row} from "react-bootstrap";
import {FormLabel} from "react-bootstrap";
import UserDataService from './services/auth.service'

function ModalForgotPassword(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [user, setUser] = useState(props.user);
	const [email, setEmail] = useState('');

  // This is how you make the current user available on any functional component
  //const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    setLgShow(true); 
  };

	const forgotPasswordEmail = () => {
		// Send forgot password email
		UserDataService.forgotPasswordEmail(email).then(response => {
			alert("A password reset link has been sent to your email address.");
		}).catch(e => {
			console.log("Error sending password reset email:", e);
			alert("An error occurred while sending the password reset email. Please try again later.");
		});
	};

	const onChangeEmail = (e) => {
		const email = e.target.value;
		setEmail(email);
	};

  return (
    <>      
      <Button style={{margin:0,padding:0,fontSize:'14px'}} onClick={handleShow} variant="link">{"Forgot your password?"}</Button>                    
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {'Forgot your password?'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
					<FormGroup>
						<FormLabel>
							Provide the email address and click on the link below to reset your password.
						</FormLabel>				
						<FormControl
							type="email"
							value={email}
							onChange={onChangeEmail}
						/>						
					</FormGroup>
					<br/>

					<FormGroup>
						<Alert variant="info" >
							Note: We will send you a recovery link to your email address. Please check your inbox and your spam folder. 
						</Alert>				
					</FormGroup>

        </Modal.Body>
        <Modal.Footer>
          <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap',justifyItems:'center',alignItems:'center',gap:'50px',alignContent:'baseline'}}>
            <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap',justifyItems:'center',alignItems:'center',gap:'10px',alignContent:'baseline'}}>
                 
            </div> 
          

            <Button onClick={() => {forgotPasswordEmail();handleClose();}} variant="primary">
              Send Password Reset Link
            </Button>
          </div>
        </Modal.Footer>

      </Modal>
    </>
  )
}

export default ModalForgotPassword;

